/**
 * Согласованность веса готового блюда с суммой весов его ингредиентов.
 *
 * Разбор жалобы 2 сентября 2026: у рецепта орехового микса в поле итогового
 * веса осталось 2 г при 25 г ингредиентов. Число уехало в дневник как вес
 * порции, карточка показывала «2 г», а попытка исправить порцию на 25 г
 * масштабировала каждый орех в 12,5 раза — потому что состав пересчитывается
 * от сохранённого веса, каким бы он ни был.
 *
 * Расходиться эти два числа обязаны: вода выпаривается при варке, крупа
 * разбухает, у сырого блюда сумма и вес совпадают. Поэтому порог грубый —
 * пятикратная разница готовкой не объясняется, так выглядит потерянная или
 * лишняя цифра при вводе.
 *
 * Спрашивать об этом можно только экран рецепта в «Кулинарии»: там число —
 * итог готового блюда. В дневнике рецепт работает шаблоном, и вес означает
 * съеденную порцию, которая законно бывает во много раз меньше состава.
 */

const MAX_RATIO = 5

export function isCookedWeightImplausible(cookedWeight, ingredientsTotal) {
  const w = Number(cookedWeight)
  const total = Number(ingredientsTotal)
  if (!(w > 0) || !(total > 0)) return false
  return w * MAX_RATIO < total || w > total * MAX_RATIO
}
